import { render, staticRenderFns } from "./RoomWalls.vue?vue&type=template&id=66379043&"
import script from "./RoomWalls.vue?vue&type=script&lang=js&"
export * from "./RoomWalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports